"use client";

import { useEffect, useState } from "react";
import { datadogRum } from "@datadog/browser-rum";

export default function DatadogInit() {
  const [nodeEnv, setNodeEnv] = useState<
    "staging" | "production" | undefined
  >();

  useEffect(() => {
    const isStaging = window.location.origin.includes(
      "www-staging.urbansportsclub",
    );

    setNodeEnv(isStaging ? "staging" : "production");
  }, []);

  if (process.env.NODE_ENV !== "production") {
    return;
  }

  if (
    !process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ||
    !process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
  ) {
    console.warn(
      "Datadog RUM is disabled. Please set an `applicationId` and `clientToken` value",
    );

    return;
  }

  if (!datadogRum.getInitConfiguration() && nodeEnv) {
    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: "datadoghq.eu",
      service: process.env.NEXT_PUBLIC_DD_SERVICE_NAME,
      env: `b2e-acquire-${nodeEnv}`,
      // Fetched from package.json version
      version: process.env.APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });
  }

  return null;
}
